export default "__VITE_ASSET__97fe17e3__"